import { Component } from 'react';

import Popover, { Props as PopoverProps } from 'components/Popover';
import onClickOutside from 'react-onclickoutside';

// TODO, more tightly control when handleClickOutside is being fired. should only happen if
// popover is open. the HOC passes down props for doing this, but need to wrapp this with another to pass in the
// disable prop

class CancellablePopover extends Component<PopoverProps> {
  handleClickOutside = () => {
    const { isOpen } = this.props;

    if (isOpen) {
      this.props.onClose();
    }
  };

  render() {
    const { children, ...rest } = this.props;
    return <Popover {...rest}>{children}</Popover>;
  }
}

export default onClickOutside(CancellablePopover);
